import { render, staticRenderFns } from "./IolResultSwitchHistory.vue?vue&type=template&id=420a50d8&scoped=true"
import script from "./IolResultSwitchHistory.vue?vue&type=script&lang=js"
export * from "./IolResultSwitchHistory.vue?vue&type=script&lang=js"
import style0 from "./IolResultSwitchHistory.vue?vue&type=style&index=0&id=420a50d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420a50d8",
  null
  
)

export default component.exports